import React from 'react';
import ModernMenu from './ModernMenu';

const Menu = () => {
  return <ModernMenu />;
};

export default Menu;
